<div class="p-g">
    <div class="p-g-12">
        <form [formGroup]="playerForm" (ngSubmit)="createPlayer()">
            <div class="inputs-group" [ngStyle]="inputsGroupStyle">
                <div class="inputs-group-row">
                    <div class="inputs-group-row-name">Email Address:</div>
                    <div class="inputs-group-row-value">
                        <input type="email" pInputText formControlName="email" />
                        <control-errors
                            [control]="playerForm.get('email')"
                            [errors]="{
                                pattern: 'The email is invalid',
                                emailMaxLength: 'The email cannot exceed {emailMaxLength} characters',
                                emailInUse: 'Email already in use, please update and try again'
                            }"></control-errors>
                    </div>
                </div>
                <div class="inputs-group-row">
                    <label for="title" class="inputs-group-row-name asterisk-mark">Title:</label>
                    <div class="inputs-group-row-value">
                        <p-dropdown
                            [options]="titleOptions"
                            [showClear]="true"
                            placeholder="Select title"
                            formControlName="title"
                            class="custom-dropdown">
                        </p-dropdown>
                        <control-errors [control]="playerForm.get('title')"></control-errors>
                    </div>
                </div>

                <div class="inputs-group-row">
                    <label for="firstName" class="inputs-group-row-name asterisk-mark">First name:</label>
                    <div class="inputs-group-row-value">
                        <input formControlName="firstName" pInputText id="firstName" />
                        <control-errors [control]="playerForm.get('firstName')"></control-errors>
                    </div>
                </div>
                <div class="inputs-group-row">
                    <label for="lastName" class="inputs-group-row-name asterisk-mark">Last name:</label>
                    <div class="inputs-group-row-value">
                        <input formControlName="lastName" pInputText id="lastName" />
                        <control-errors [control]="playerForm.get('lastName')"></control-errors>
                    </div>
                </div>
                <div class="inputs-group-row">
                    <label class="inputs-group-row-name asterisk-mark">
                        <naming-convention-label [type]="'Group'"></naming-convention-label>:
                    </label>
                    <div class="inputs-group-row-value">
                        <organization-groups (organizationsIds)="getOrgId($event)" formControlName="organizationGroups"></organization-groups>
                        <control-errors [control]="playerForm.get('organizationGroups')"></control-errors>
                    </div>
                </div>
                <div class="inputs-group-row">
                    <div class="inputs-group-row-name asterisk-mark">Date of Birth:</div>
                    <div class="inputs-group-row-value">
                        <p-calendar appendTo="body" [showIcon]="true" formControlName="dateOfBirth"></p-calendar>
                        <control-errors [control]="playerForm.get('dateOfBirth')"></control-errors>
                    </div>
                </div>
                <div class="inputs-group-row">
                    <div class="inputs-group-row-name asterisk-mark">Sex:</div>
                    <div class="inputs-group-row-value">
                        <p-dropdown
                            [options]="genders"
                            [showClear]="true"
                            formControlName="gender"
                            appendTo="body"
                            placeholder="Select sex">
                        </p-dropdown>
                        <control-errors [control]="playerForm.get('gender')"></control-errors>
                    </div>
                </div>

                <div class="inputs-group-row" *ngIf="isIdentityVerificationMandatory">
                    <label for="identification-type" class="inputs-group-row-name asterisk-mark">Identity Verification:</label>
                    <div class="inputs-group-row-value">
                        <p-dropdown
                            id="identification-type"
                            formControlName="identificationType"
                            [options]="identityVerificationOptions"
                            placeholder="Select verification method"
                            [showClear]="true"
                            class="custom-dropdown">
                        </p-dropdown>
                        <control-errors
                            [control]="playerForm.get('identificationType')"
                            [errors]="{ required: 'Identity verification is required' }">
                        </control-errors>
                    </div>
                </div>

                <div class="inputs-group-row">
                    <div class="inputs-group-row-name">Phone No.:</div>
                    <div class="inputs-group-row-value">
                        <input type="text" pInputText formControlName="phoneNumber" />
                        <control-errors
                            [control]="playerForm.get('phoneNumber')"
                            [errors]="{ pattern: 'The phone number is invalid' }"></control-errors>
                    </div>
                </div>

                <div class="inputs-group-row">
                    <patient-consent formControlName="consentToUpdate"> </patient-consent>
                </div>

                <div class="inputs-group-row">
                    <form-buttons allowOffline [disabled]="playerForm.invalid" [saving]="creatingPlayer" [config]="buttonsConfig">
                    </form-buttons>
                </div>
            </div>
        </form>
    </div>
</div>

<duplicate-patients-dialog
    *ngIf="duplicatesDialogVisible"
    [duplicates]="duplicatePatients"
    [currentPatient]="playerForm.value"
    [(visible)]="duplicatesDialogVisible"
    [organizationGroupsIds]="organizationGroups"
    (completed)="emitPatient($event)"></duplicate-patients-dialog>
